const icon = require('vue-svgicon');
icon.register({
    'burger': {
        width: 22,
        height: 22,
        viewBox: '0 0 22 22',
        data: `<path pid="0" clip-rule="evenodd" d="M1.1 18.578h19.8a1.1 1.1 0 010 2.2H1.1a1.1 1.1 0 010-2.2zm0-8.802h8.8a1.1 1.1 0 010 2.201H1.1a1.1 1.1 0 010-2.2zM22 2.566a1.1 1.1 0 00-1.1-1.1H1.1a1.1 1.1 0 100 2.2h19.8a1.1 1.1 0 001.1-1.1z"/>`,
    },
});
